module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-2021-1.3136fb82.jpg";